import { datadogLogs } from "@datadog/browser-logs";
import { useEffect, useRef } from "react";

export function DatadogLogs() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    datadogLogs.init({
      clientToken: "pubc7b1f9f3d8b920cbee825efa2895f3d8",
      site: "datadoghq.com",
      service: "remora",
      forwardErrorsToLogs: true,
      forwardConsoleLogs: "all",
      sessionSampleRate: 100,
    });
  }, []);

  return null;
}
